import Localization from "../../../../localization";
import { Form } from "../../../../components";
import React, { useRef } from "react";

const EditRecipient = ({
  onSave = async () => {},
  isOwner = false,
  isNew = true,
  recipient = {},
  recipients = [],
}) => {
  const modifyContactFormRef = useRef();

  return (
    <>
      <Form
        preserve={false}
        initialValues={recipient}
        ref={modifyContactFormRef}
        fields={[
          !isOwner && {
            name: "name",
            label: Localization.general.name,
            placeholder: Localization.placeholder.recipients_name,
            rules: [
              {
                required: true,
                message: Localization.feedback.required_recipient_name,
              },
            ],
          },
          isNew && {
            name: "endpoint",
            label: Localization.general.mobile_number,
            placeholder: isOwner
              ? Localization.placeholder.enter_your_number
              : Localization.placeholder.recipients_mobile_number,
            rules: [
              { type: "phone", required: true },
              {
                validator: async (_, value) =>
                  !recipients.map((_) => _.endpoint).includes(value)
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error(
                          Localization.feedback.recipient_mobile_number_exist
                        )
                      ),
              },
            ],
          },
        ].filter(Boolean)}
      />
      <Form.Submit
        type={"primary"}
        className="m-30-t"
        title={!isNew ? Localization.general.save : Localization.general.add}
        onClick={async () => {
          await modifyContactFormRef.current.validateFields();
          await onSave(
            modifyContactFormRef.current.getFieldsValue({
              format: { name: "phone", key: "endpoint" },
            })
          );
        }}
      />
    </>
  );
};

export default EditRecipient;
